import React from 'react'
import InviteUserDrawer from './InviteUserDrawer'
import { PlusOutlined } from '@ant-design/icons'
import { userActions } from '../../../../../store/slices/user.slice'
import { Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import userSelectors from '../../../../../store/selectors/user.selectors'

const InviteUserButton = () => {
    const dispatch = useDispatch()
    const showInviteUserDrawer = useSelector(userSelectors.showInviteUserDrawer)

    return (
        <>
            <Button
                icon={<PlusOutlined aria-hidden='true' />}
                onClick={() => dispatch(userActions.setShowInviteUserDrawer(true))}
                type='primary'
            >
                Invite user
            </Button>
            {showInviteUserDrawer && <InviteUserDrawer />}
        </>
    )
}

export default InviteUserButton
